import React from "react";
import { Container, Title, SectionDivider } from './VolunteerStyles'

const Volunteer = () => (
    <div id="volunteer">
        <SectionDivider />
        <Container>
            <Title>Volunteer Work</Title>
        </Container>
    </div>
);

export default Volunteer;